<template>
  <router-view />
</template>


<script>

// let dom = document.createElement('script')
// dom.setAttribute('type','text/javascript')
// dom.setAttribute('src','http://webapi.amap.com/maps?v=1.4.4&key=c6979f9121ed9d1d6cd46f5fc2ab30e3&plugin=AMap.Geocoder')

// document.body.appendChild(dom)

export default {
  name: 'App',



}
</script>

<style lang="scss">
  @import "./style/reset.scss";
  @import "./style/base.scss";
  //放大镜位置
  .mouse-cover-canvas {
    position: absolute;
    top: 173px !important;
    left: 740px !important;
  }
</style>
